import styled from "styled-components";

const SpeechAnalytics = styled.div`
    display: grid;
    grid-template-columns: repeat(24, 1fr);
    grid-template-rows: 1fr;
    background-color: #424242;

`
export default SpeechAnalytics;